import api from "./api.js";

export default class BannerApi {
  static async add(data) {
    return await api.post(`banner`, data);
  }
  static async get(data) {
    return await api.get(`banner`, data);
  }
  static async delete(data) {
    return await api.del(`banner`, data);
  }
  static async update(id, data) {
    return await api.patch(`banner/${id}`, data);
  }
}
